// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CalendarOverview from './components/CalendarOverview';
import DashboardLayout from './components/DashboardLayout';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/ProtectedRoute';
import TimeTracking from './components/TimeTracking';
import Settings from './components/Settings';
import EntriesList from './components/EntriesList';
import CustomersList from './components/CustomersList'; // Importieren der neuen Komponente
import { ToastContainer } from 'react-toastify';
import ExpenseManagement from './components/ExpenseManagement';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboardinfo from './components/Dashboardinfo';
import ReportView from './components/ReportView'; // Importieren der neuen Komponente
import PivotReports from './components/PivotReports';

function App() {
  return (
    <Router>
      <Routes>
      
        {/* Öffentlich zugängliche Routen */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* Geschützte Routen */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Default Route innerhalb des Dashboards */}
          <Route index element={<Navigate to="/overview" replace />} />

          {/* Definierte Routen */}
          <Route path="overview" element={<CalendarOverview />} />
          <Route path="timetracking" element={<TimeTracking />} />
          <Route path="entries" element={<EntriesList />} />
          <Route path="customers" element={<CustomersList />} /> {/* Neue Route */}
          <Route path="settings" element={<Settings />} />
          <Route path="expensemanagement" element={<ExpenseManagement />} />
          <Route path="dashboardinfo" element={<Dashboardinfo />} />
          <Route path="reportview" element={<ReportView />} />
         {/* <Route path="pivotreports" element={<PivotReports />} />*/}
        </Route>

        {/* Fallback für nicht definierte Routen */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={5000} />
    </Router>
  );
}

export default App;
